<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="pt-1">
          <span class="headline font-weight-medium">Usuarios</span>
        </v-col>
        <v-col cols="4" class="pt-1">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="descargaReporte()"
            style="margin-left:5%"
            v-if="this.$hasPermision('empleados.download')"
          >
            Descargar XLS
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('empleados.create')"
            dark
            color="#023145"
            width="120"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_employee"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('empleados.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="employees"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todos los usuarios
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.fullname="{ item }">
                <span class="font-weight-medium">{{ item.fullname }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
                <br />
                <v-icon v-if="item.email" class="mr-1" size="13" color="#303197"
                  >fas fa-envelope</v-icon
                >
                <span class="font-italic email-company">
                  {{ item.email }}
                </span>
              </template>

              <template v-slot:item.fecha_ingreso="{ item }">
                <span v-if="item.fecha_ingreso != null">{{
                  item.fecha_ingreso
                }}</span>
                <span v-else> - </span>
              </template>
              <template v-slot:item.puesto="{ item }">
                <span>{{ item.puesto ? item.puesto.nombre : "-" }}</span>
              </template>

              <!--<template v-slot:item.has_access="{item}">
                                <span v-if="item.has_access">SI</span>
                                <span v-else>NO</span>
                            </template>

                            <template v-slot:item.username="{item}">
                                <span v-if="item.user">{{ item.user.username }}</span>
                            </template>-->

              <template v-slot:item.role_name="{ item }">
                <span v-if="item.user">
                  {{ item.user.role_names }}
                </span>
              </template>

              <template v-slot:item.payment_type="{ item }">
                <span v-if="item.payment_type === 'RECIBO HONORARIO'">
                  Salario: {{ item.salary }}
                </span>
                <span v-else-if="item.payment_type === 'SALARIO'">
                  Salario: {{ item.salary | currency("S/") }}
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="this.$hasPermision('empleados.edit')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <v-btn
              v-if="
                show_btn_active && this.$hasPermision('empleados.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="
                !show_btn_active &&
                  this.$hasPermision('empleados.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('empleados.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('empleados.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="modalBaja"
            >
              <v-icon class="mr-2" size="16">mdi-cancel</v-icon>
              Dar de Baja
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>
    <Baja ref="Baja"></Baja>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/employees/CreateUpdate";
import Filters from "../../../components/employees/Filters";
import Baja from "../../../components/employees/Baja";

export default {
  name: "Employees",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
    Baja,
  },
  data() {
    return {
      search_employee: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Seguridad",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "NOMBRES Y APELLIDOS", value: "fullname", sortable: false },
        { text: "DOCUMENTO", value: "document", sortable: false },
        { text: "FEC. NACIMIENTO", value: "birthday", sortable: false },
        { text: "TELÉFONO", value: "phone", sortable: false },
        // {
        //   text: "FECHA DE INGRESO",
        //   value: "fecha_ingreso",
        //   sortable: false,
        //   width: 150,
        //   align: "center",
        // },
        // {
        //   text: "PUESTO",
        //   value: "puesto",
        //   sortable: false,
        //   width: 150,
        //   align: "center",
        // },
        /*{ text: 'USUARIO', value: 'username', sortable: false },*/
        { text: "ROL", value: "role_name", sortable: false },
        // { text: "TIPO DE PAGO", value: "payment_type", sortable: false },
      ],
      is_download: false,
    };
  },
  computed: {
    ...mapState("employees", ["employees", "file_employees"]),
  },
  methods: {
    ...mapActions("employees", [
      "getEmployees",
      "change_status",
      "delete",
      "employeeDownload",
    ]),
    ...mapActions("offices", ["getAvailables"]),
    ...mapActions("roles", ["getRoles"]),
    ...mapActions("bonos", ["bonoActivos"]),
    async descargaReporte() {
      this.is_download = true;
      let nameReporte = "Empleados.xlsx"; //this.emptyFileSales();
      //let filters_data = Object.assign({}, this.filters);
      //filters_data.company_id = this.company_id;
      await this.employeeDownload();
      this.is_download = false;
      if (this.file_employees) {
        // console.log(this.file_employees);
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_employees;
        window.open(url);
      }
    },
    modalBaja() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.Baja.showForm("Dar de Baja Empleado", employee);
    },
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo Usuario", "create");
    },
    handleEdit() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de usuario",
        "update",
        employee
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de usuario");
    },
    async getAllEmployees() {
      await this.getEmployees();
      await this.bonoActivos();
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        fullname: this.search_employee,
      };
      await this.getEmployees(filters);
    },
    async handleChangeStatus() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(employee);
    },
    async handleDelete() {
      let employee = this.selectedRows[0];
      await this.delete(employee);
      this.selectedRows = [];
      this.showOptionCrud();
    },
  },
  created() {
    this.getAllEmployees();
    this.getAvailables();
    this.getRoles();
  },
};
</script>

<style scoped></style>
